export default __webpack_public_path__ + "static/media/png.5a29a489.svg";